//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from 'vuex'

export default {
  name: 'QuickMenus',
  computed: {
    ...mapGetters([
      'tradeConfig',
      'vcId'
    ])
  },
  methods: {
    quickTrade () {
      if (!this.vcId) {
        this.$store.dispatch('setVcId', this.tradeConfig[0].vcId)
      }
      this.$router.push('/trade')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/QuickMenus/QuickMenus.vue